import React from 'react';
import { Phone, Mail, MapPin, Clock, Instagram, Youtube, Linkedin } from 'lucide-react';
import './FooterSection.css';

const FooterSection = () => {
  return (
    <footer className="main-footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* LOGO & HAKKINDA */}
          <div className="footer-brand">
            <h2 className="f-logo">Op. Dr. <span>Mahmut</span> Aluç</h2>
            <p className="f-desc">
              Çocuk cerrahisinde 30 yıllık tecrübe ile minik kahramanlarımıza 
              modern, akademik ve şefkatli tedavi çözümleri sunuyoruz.
            </p>
            <div className="social-icons">
              <a href="#" className="s-icon"><Instagram size={20}/></a>
              <a href="#" className="s-icon"><Youtube size={20}/></a>
              <a href="#" className="s-icon"><Linkedin size={20}/></a>
            </div>
          </div>

          {/* HIZLI LİNKLER */}
          <div className="footer-links">
            <h4>Hızlı Erişim</h4>
            <ul>
              <li><a href="/">Ana Sayfa</a></li>
              <li><a href="/hakkimizda">Hakkımızda</a></li>
              <li><a href="/uzmanliklar">Uzmanlıklar</a></li>
              <li><a href="/iletisim">İletişim</a></li>
            </ul>
          </div>

          <div className="footer-contact-info">
            <h4>İletişim Bilgileri</h4>
            <ul className="contact-list">
              <li>
                <MapPin size={22} className="c-icon" />
                <span>
                  Mehmet Akif Ersoy Mah. 49-4. Sk. Hisar Ofis No: 5 Kat: 1 Daire: 102 Merkez/Sivas
                </span>
              </li>
              <li>
                <Phone size={18} className="c-icon" />
                <div className="footer-phones">
                  <a href="tel:+905076444022">0 (507) 644 40 22</a> <br />
                  <a href="tel:+905423666626">0 (542) 366 66 26</a>
                </div>
              </li>
              <li>
                <Mail size={18} className="c-icon" />
                <span>info@mahmutaluc.com.tr</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Op. Dr. Mahmut Aluç. Tüm Hakları Saklıdır.</p>
          <div className="footer-legal">
            <a href="#">Gizlilik Politikası</a>
            <a href="#">KVKK Metni</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;